module.exports = __webpack_public_path__ + "img/img_loto_vert.e3166e8f.png";